<script>
import { getOpeningsUrl, getOpeningsLabel } from '@/data/openings'
import UserTypeGetter from '@/data/userTypes/UserTypeGetter'

const getBtnColor = type => UserTypeGetter.getType( type ).color

export default {
    render(h) {
        const headline = h('strong', {
            class: 'text--upper'
        }, 'Join Us')
        const buttons = [
            h('a', {
                class: `button button--${getBtnColor('experienced')}`,
                domProps: {
                    innerHTML: getOpeningsLabel('experienced'),
                    target: '_blank',
                    rel: 'noopener',
                    href: getOpeningsUrl('experienced')
                }
            }),
            h('a', {
                class: `button button--${getBtnColor('student')}`,
                domProps: {
                    innerHTML: getOpeningsLabel('student'),
                    target: '_blank',
                    rel: 'noopener',
                    href: getOpeningsUrl('student')
                }
            }),
        ]

        return h('div', {
            attrs: {
                'data-flex': 'column'
            },
            class: 'outro outro--stack has-overflow'
        }, [
            headline,
            ...buttons
        ])
    }
}
</script>